import React from 'react';
import classNames from 'classnames';

var Pill = function Pill(_ref) {
    var _ref$isSelected = _ref.isSelected,
        isSelected = _ref$isSelected === undefined ? false : _ref$isSelected,
        onRemove = _ref.onRemove,
        text = _ref.text;
    return React.createElement(
        'span',
        { className: classNames('pill', { 'is-selected': isSelected }) },
        React.createElement(
            'span',
            { className: 'pill-text' },
            text
        ),
        React.createElement(
            'span',
            { 'aria-hidden': 'true', className: 'close-btn', onClick: onRemove },
            '\u2715'
        )
    );
};

Pill.propTypes = {
    isSelected: PropTypes.bool,
    onRemove: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
};
export default Pill;
import PropTypes from 'prop-types';